import React from "react";

import './spinner.css';

const Spinner = () => {
    return <div className="spinner-main">
        <img src="/images/bag.png" className="spinner-img" alt="logo"/>
    </div>
}

export default Spinner;